
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import ProjectCard from "./ProjectCard";
import colorSharp2 from "../assets/img/color-sharp2.png";
import BB from '../assets/images/event-logo/bb.jpg';
import CC from '../assets/images/event-logo/cc.jpeg';
import COW from '../assets/images/event-logo/cow.jpg';
import PV from '../assets/images/event-logo/prompt.jpeg';
import 'animate.css';
import TE from '../assets/images/event-logo/te.jpeg';
import PPC from '../assets/images/event-logo/ppc.webp';
import WI from '../assets/images/event-logo/wi.jpg';
import GE from '../assets/images/event-logo/ge.avif';
import PP from '../assets/images/event-logo/pp.webp';
import ES from '../assets/images/event-logo/ff.webp';
import TrackVisibility from 'react-on-screen';
/*import BBD from '../assets/pdf/BB.png';
import CCD from '../assets/pdf/CC.png';
import COWD from '../assets/pdf/CC.png';
import PVD from '../assets/pdf/PV.png';

import TED from '../assets/pdf/TE.png';
import PPCD from '../assets/pdf/PPC.png';
import WID from '../assets/pdf/WI.png';
import GED from '../assets/pdf/GE.png';
import PPD from '../assets/pdf/PP.png';*/

const Projects = () => {
  const projects = [
    {
      title: "Brain Buster",
      eventType: "technical",
      description: "Tech Talk, Debate",
      imgUrl: BB,
      pdfUrl: "/BB.pdf",
    },
    {
      title: "Code Chaos",
      eventType: "technical",
      description: "Code the code",
      imgUrl: CC,
      pdfUrl: "/CC.pdf",
    },
    {
      title: "Code of Wars",
      eventType: "technical",
      description: "Code to survive",
      imgUrl: COW,
      pdfUrl: "/COW.pdf",
    },
    {
      title: "Prompt Verse",
      eventType: "technical",
      description: "Observe, Prompt, Victory",
      imgUrl: PV,
      pdfUrl: "/PV.pdf",
    },
    {
      title: "Third Eye",
      eventType: "nontechnical",
      description: "See from Mind",
      imgUrl: TE,
      pdfUrl: "/TE.pdf",
    },
    {
      title: "Picturific Pantamonium",
      eventType: "nontechnical",
      description: "Pic stick word",
      imgUrl: PPC,
      pdfUrl: "/PPC.pdf",
    },
    {
      title: "What IF... ?",
      eventType: "nontechnical",
      description: "Quizzz",
      imgUrl: WI,
      pdfUrl: "/WI.pdf",
    },
    {
      title: "Free Fire",
      eventType: "nontechnical",
      description: "Born to SURVIVE",
      imgUrl: ES,
      pdfUrl: "/FF.pdf",
    },
    {
      title: "Great Escape",
      eventType: "nontechnical",
      description: "Think Different",
      imgUrl: GE,
      pdfUrl: "/GE.pdf",
    },
    {
      title: "Project Presentation",
      eventType: "pp",
      description: "Prototype, PPT",
      imgUrl: PP,
      pdfUrl: "/PP.pdf",
    }
  ];

  // Function to handle card click and open PDF
  const handleCardClick = (pdfUrl) => {
    window.open(pdfUrl, "_blank");
  };

  return (
    <section className="project" id="events">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>EVENTS</h2>
                  <p style={{ color: "gold" }}>
                    Select an event type to view details.
                    <br />
                    <b >💵 Rs.10,000</b> Prize-Pool for Project Presentation and 💵 Cash rewards for Technical events and Exciting rewards for Non-Technical events
                  </p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">Technical</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Non-Technical</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Project Presentation</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                      <Tab.Pane eventKey="first">
                        <Row className="d-flex justify-content-center">
                          {projects
                            .filter((project) => project.eventType === "technical")
                            .map((project, index) => (
                              <ProjectCard key={index} {...project} onClick={() => handleCardClick(project.pdfUrl)} />
                            ))}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <Row className="d-flex justify-content-center">
                          {projects
                            .filter((project) => project.eventType === "nontechnical")
                            .map((project, index) => (
                              <ProjectCard key={index} {...project} onClick={() => handleCardClick(project.pdfUrl)} />
                            ))}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <Row className="d-flex justify-content-center">
                          {projects
                            .filter((project) => project.eventType === "pp")
                            .map((project, index) => (
                              <ProjectCard key={index} {...project} onClick={() => handleCardClick(project.pdfUrl)} />
                            ))}
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="background" />
    </section>
  );
};

export default Projects;
